import { useEffect, useRef } from "react";

export function TargetCursor() {
  const cursorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const finePointer = window.matchMedia("(pointer: fine)");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    if (!cursor || !finePointer.matches || reduceMotion.matches) return;

    let frame = 0;
    let x = -40;
    let y = -40;

    const render = () => {
      cursor.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      frame = 0;
    };
    const onMove = (event: PointerEvent) => {
      x = event.clientX;
      y = event.clientY;
      cursor.classList.add("is-visible");
      if (!frame) frame = window.requestAnimationFrame(render);
    };
    const onOver = (event: PointerEvent) => {
      const target = event.target as HTMLElement;
      cursor.classList.toggle("is-targeting", Boolean(target.closest("[data-target], a, button")));
    };
    const onLeave = () => cursor.classList.remove("is-visible");

    window.addEventListener("pointermove", onMove);
    document.addEventListener("pointerover", onOver);
    document.documentElement.addEventListener("mouseleave", onLeave);
    return () => {
      window.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerover", onOver);
      document.documentElement.removeEventListener("mouseleave", onLeave);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return <div ref={cursorRef} className="target-cursor" aria-hidden="true" />;
}
